// extracted by mini-css-extract-plugin
module.exports = {"tabListContainer":"_8f9842d"};